"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimatePriorityFee = void 0;
async function estimatePriorityFee(rpcUrl, accountKeys, options = { recommended: true }) {
    const response = await fetch(rpcUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            jsonrpc: '2.0',
            id: '1',
            method: 'getPriorityFeeEstimate',
            params: [
                {
                    accountKeys,
                    options,
                },
            ],
        }),
    });
    const data = await response.json();
    if ('error' in data) {
        throw Error(JSON.stringify(data.error));
    }
    return parseInt(data.result.priorityFeeEstimate);
}
exports.estimatePriorityFee = estimatePriorityFee;
//# sourceMappingURL=priority-fee.js.map